import React from "react";
import Reveal from "./Reveal";
import { positioningStatement } from "../mock";

const PositioningStatement = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 text-center md:px-8">
        <Reveal>
          <p className="text-2xl font-light leading-relaxed text-[#0F2A4A] md:text-[34px] md:leading-[1.4]">
            {positioningStatement}
          </p>
        </Reveal>
        <Reveal delay={120}>
          <div className="mx-auto mt-10 h-px w-16 bg-[#E4545F]" />
        </Reveal>
      </div>
    </section>
  );
};

export default PositioningStatement;
